import { useState } from "react";

export default function InfoIcon({ info, className = "" }) {
  const [hovered, setHovered] = useState(false);
  return (
    <div className={`relative flex items-center ${className}`}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-4 h-4 text-gray-500 cursor-pointer"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M13 16h-1v-4h-1m1-4h.01M12 20a8 8 0 100-16 8 8 0 000 16z"
        />
      </svg>
      {hovered && (
        <div className="absolute left-6 top-1/2 -translate-y-1/2 bg-black text-white text-xs px-2 py-1 rounded z-10 whitespace-nowrap">
          {info}
        </div>
      )}
    </div>
  );
}
